"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKeyReturn = function (e) {
    return e.key === 'Enter' || e.keyCode === 13;
};
exports.isKeyEscape = function (e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};
exports.isKeySpacebar = function (e) {
    return e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32;
};
exports.isKeyArrowLeft = function (e) {
    return e.key === 'ArrowLeft' || e.key === 'Left' || e.keyCode === 37;
};
exports.isKeyArrowUp = function (e) {
    return e.key === 'ArrowUp' || e.key === 'Up' || e.keyCode === 38;
};
exports.isKeyArrowRight = function (e) {
    return e.key === 'ArrowRight' || e.key === 'Right' || e.keyCode === 39;
};
exports.isKeyArrowDown = function (e) {
    return e.key === 'ArrowDown' || e.key === 'Down' || e.keyCode === 40;
};
